@use "variables" as *;

.container {
  position: relative;
  width: 100%;
  display: flex;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: $spacing-m;
    top: 0;
    bottom: 0;
    margin: auto 0;
    align-items: center;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
  .hideOnHover {
    visibility: visible;
  }
  &:hover .hideOnHover {
    visibility: hidden;
  }
}

.hoverButton {
  width: 24px;
  height: 24px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.hoverButtonIcon {
  font-size: $fontSize-l !important;
}

.position {
  width: 40px;
  font-size: $fontSize-xxs;
  font-weight: bolder;
  text-align: center;
  flex-shrink: 0;
  font-variant: tabular-nums;
}

.name {
  font-size: $fontSize-xs;
  font-weight: bold;
}

.extraArtists {
  font-size: $fontSize-xxs;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.length {
  width: 54px;
  font-size: $fontSize-xxs;
  font-weight: bold;
  text-align: center;
  flex-shrink: 0;
  font-variant: tabular-nums;
}

.loading {
  margin-right: 16px !important;
  width: 14px !important;
  height: 14px !important;
}
